const nl2br = (text) => {
    return text ? text.replace(/\\n/g,"<br />") : null;
}

module.exports = { nl2br }